<template>
  <v-container fluid>
    <gg-card>
      <gg-card-header>
        What to Expect
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <v-sheet>
              <p>To get started, we will ask a few simple questions about your project or company and what type of website you would like to create.</p>
              <p>Once your request is submitted, our team will use the elements provided and start working on your new custom multi-page Starter Site.</p>
            </v-sheet>
          </v-col>
          <v-col cols="12" class="py-0">
            <h4>How Long Does It Take?</h4>
          </v-col>
          <v-col cols="12">
            <v-sheet>
              <p>We typically complete requests within 24-72 hours and process Starter Site requests on a first-come, first-served basis.</p>
              <p>Our Starter Site team will contact you once the draft website is ready or if additional information is required.</p>
            </v-sheet>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>
  </v-container>
</template>

<script>
export default {
  name: 'StarterSite'
}
</script>
